export const FONT_SIZE_CLASS_NAME = 'text';
export const LINE_HEIGHT_CLASS_NAME = 'leading';

export default {
  FONT_SIZE_CLASS_NAME,
  LINE_HEIGHT_CLASS_NAME,
};
